import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Monitor } from 'lucide-react';
import './MobileOnlyDesktopNotice.css';

/**
 * Renders a friendly "Desktop only" notice for admin/configuration
 * pages that aren't appropriate for the mobile workflow. The page
 * decides whether to render this (when on mobile) or its real content
 * (when on desktop).
 */
export default function MobileOnlyDesktopNotice({ pageName, description }) {
  const navigate = useNavigate();
  return (
    <div className="mobile-only-desktop-notice">
      <div className="mobile-only-desktop-notice-icon" aria-hidden="true">
        <Monitor size={48} strokeWidth={1.5} />
      </div>
      <h2 className="mobile-only-desktop-notice-title">
        {pageName ? `${pageName} is desktop-only` : 'Desktop-only page'}
      </h2>
      <p className="mobile-only-desktop-notice-body">
        {description ||
          'This screen is not optimized for phones or tablets in portrait mode. Please open it on a desktop browser to make changes.'}
      </p>
      <div className="mobile-only-desktop-notice-actions">
        <button
          type="button"
          className="mobile-only-desktop-notice-btn"
          onClick={() => navigate('/')}
        >
          Go to dashboard
        </button>
        <button
          type="button"
          className="mobile-only-desktop-notice-btn mobile-only-desktop-notice-btn--secondary"
          onClick={() => navigate('/patients')}
        >
          Patients
        </button>
      </div>
    </div>
  );
}
